import "./router/router0"
import Vue from "vue";
import App from "./App.vue";
import { makeStore } from "./store";
import ElementUI from "element-ui";

import "element-ui/lib/theme-chalk/index.css";
import "@/utils/rem";
import "./directive/index";
import "./registerComponents"

import api from "./api";
import { makeI18n } from "./i18n";
import { install as globalInstall } from "./plugins/global";
import "./sass/index.scss";
import { transMixin, transMixinApi } from "./mixin/trans";
import { makeRouter } from "./router";
import { gRouter, gStore, gVm } from "./global";
import { install as permissionInstall } from './plugins/permission'
import { utilMixin } from "./mixin/util";
import "./config/fa"
import { themeInit } from "./utils/theme";
import { hackInput } from "./hack/hackInput";
import { updateDayLocale } from "./utils/datetime";

Vue.config.productionTip = false;

Vue.use(ElementUI);
// Vue.use(Fragment.Plugin)

Vue.use(api);
Vue.use(globalInstall);

// Vue.mixin(transMixin)
Vue.use(transMixinApi)
Vue.mixin(utilMixin)

const i18n = makeI18n()
hackInput(i18n)
document.body.dataset['locale'] = i18n.locale
updateDayLocale(i18n.locale)

const store = makeStore(i18n)
const router = makeRouter(store)
// makePermission(store)
Vue.use(permissionInstall, store)

gStore.value = store
gRouter.value = router
themeInit()



const app = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");


app.$watch('$i18n.locale', (locale) => {
    // 留点时间给 localeStorage
    setTimeout(() => {
        window.location.reload()
    }, 20)
})
gVm.value = app
// 监听卸载操作
// window.addEventListener("unmount", function () {
//   app.$destroy();
// });
